import { createSlice } from '@reduxjs/toolkit';

export const changeShippingModel = createSlice({
  name: 'changeShippingModel',
  initialState: {
    data: false,
  },

  reducers: {
    setChangeShippingModel: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setChangeShippingModel } = changeShippingModel.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.isLoading`
export const getChangeShippingModel = (state) => state.changeShippingModel.data;

export default changeShippingModel.reducer;
